/* import __COLOCATED_TEMPLATE__ from './set-up-messenger-visitors.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();